import { Link } from 'react-router-dom';

export function Brand({ footer = false }: { footer?: boolean }) {
  return (
    <Link className={`brand ${footer ? 'brand--footer' : ''}`} to="/" aria-label="A3GS Tec — página inicial">
      <img src="/assets/logo-a3gs.png" alt="A3GS Tec" />
      <span>A3GS<span className="brand-accent">Tec</span></span>
    </Link>
  );
}
